export function getEntityTabFilterBarApiUrl({
  baseApi,
  scopeFilterKey,
  scopeId,
}) {
  if (scopeFilterKey && scopeId != null) {
    const params = new URLSearchParams({ [scopeFilterKey]: scopeId })

    return `${baseApi}?${params}`
  }
}
